import { notification } from 'antd';
import { CallAnsweredElsewhereNotification } from '@components/call-answered-elsewhere-notification';
import { useCallAnsweredElsewhereStore } from './call-answered-elsewhere.store';

export const CALL_PICKED_UP_ELSEWHERE_TOAST_KEY = 'call-picked-up-elsewhere';

export type CallAnsweredElsewherePayload = {
  clientId?: number | null;
  receiverName?: string | null;
  receiverAvatarUrl?: string | null;
  callerName?: string | null;
  messageConversationId?: number | null;
  agentId?: number | null;
};

export function notifyCallAnsweredElsewhere({
  clientId,
  receiverName,
  receiverAvatarUrl,
  callerName,
  messageConversationId,
  agentId,
}: CallAnsweredElsewherePayload) {
  useCallAnsweredElsewhereStore.setState({
    clientId: clientId ?? null,
    messageConversationId: messageConversationId ?? null,
    agent: agentId
      ? {
          id: agentId,
          name: receiverName ?? null,
          avatarUrl: receiverAvatarUrl ?? null,
        }
      : null,
  });

  notification.open({
    key: CALL_PICKED_UP_ELSEWHERE_TOAST_KEY,

    message: null,

    description: (
      <CallAnsweredElsewhereNotification
        receiverName={receiverName}
        receiverAvatarUrl={receiverAvatarUrl}
        callerName={callerName}
        onClose={() => {
          useCallAnsweredElsewhereStore.setState({ clientId: null });
          notification.destroy(CALL_PICKED_UP_ELSEWHERE_TOAST_KEY);
        }}
      />
    ),
    duration: 5,
    placement: 'top',
    className: 'call-answered-elsewhere-notice',
    closeIcon: null,
  });
}

export function dismissCallAnsweredElsewhereIfCompleted(completedCallClientId?: number | null) {
  const { clientId: activeClientId } = useCallAnsweredElsewhereStore.getState();
  if (activeClientId === null || completedCallClientId == null || completedCallClientId !== activeClientId) return;
  notification.destroy(CALL_PICKED_UP_ELSEWHERE_TOAST_KEY);
  useCallAnsweredElsewhereStore.setState({ clientId: null, messageConversationId: null, agent: null });
}
